import React from "react";

import { FaPhone } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import { MdOutlinePlace } from "react-icons/md";

import Orcid from "./icons/OrcidIcon.png"
import WebOfScience from "./icons/WebOfScienceIcon.png"
import ProfilPhoto from "./icons/ProfilPhoto.png";
import Tuke from "./icons/TukeIcon.jpg";
import Scholar from "./icons/Google_Scholar_logo_2015.png";
import Scopus from "./icons/SCOPUS.png";
import SciProfile from "./icons/SciProfile.png";

import './Profile.css';
 
function Profile() {
  return (
    <div className="container mt-4">
      <h1 className="text-center">doc. Ing. Ján KIZEK, PhD.</h1>
      <hr className="mb-4" style={{ color: "#999999", height: "5px" }} />

      <img 
        src={ProfilPhoto} 
        alt="Profilová fotografia" 
        className="rounded-circle img-fluid mb-3" 
        style={{ width: "150px", height: "150px", objectFit: "cover" }} 
        />


      <h4>Kontakt</h4>
      <ul>
        <li><MdOutlineEmail /> <strong>Email:</strong> jan.kizek@tuke.sk</li>
        <li><FaPhone /> <strong>Telefón:</strong> +421-55-602-6329</li>
        <li><MdOutlinePlace /><strong>Adresa:</strong> Štúrova 31, 080 01 Prešov</li>
      </ul>

      <h4>Výskumné profily</h4>
        <div className="research-profiles">
        <div className="profile-item">
            <img src={WebOfScience} alt="Web Of Science"  width={30} />
            <a href="http://www.researcherid.com/rid/B-2926-2015" target="_blank" rel="noopener noreferrer">
            WEB OF SCIENCE
            </a>
        </div>
        <div className="profile-item">
            <img src={Orcid} alt="Orcid"  width={30}/>
            <a href="http://orcid.org/0000-0003-1035-9415" target="_blank" rel="noopener noreferrer">
            ORCID
            </a>
        </div>
        <div className="profile-item">
            <img src={Scholar} alt="Scholar"  width={30} />
            <a href="https://scholar.google.com/citations?hl=sk&user=IwhmjZsAAAAJ" target="_blank" rel="noopener noreferrer">
            Google Scholar
            </a>
        </div>

        <div className="profile-item">
            <img src={Scopus} alt="Scopus"  width={30} />
            <a href="https://www.scopus.com/authid/detail.uri?authorId=6508127947" target="_blank" rel="noopener noreferrer">
            Scopus
            </a>
        </div>

        <div className="profile-item">
            <img src={SciProfile} alt="Sci Profile"  width={30} />
            <a href="https://sciprofiles.com/profile/590321" target="_blank" rel="noopener noreferrer">
            SciProfiles
            </a>
        </div>

        


        </div>

      
      <hr className="custom-hr"/>

      

      <h4>Člen redakčných rád</h4>
      <ul>
        <li>The Holistic Approach to Environment: <a href="https://casopis.hrcpo.com/" target="_blank" rel="noopener noreferrer">https://casopis.hrcpo.com/</a></li>
        <li>Civil and Environmental Engineering Reports: <a href="http://www.ceer.uz.zgora.pl/" target="_blank" rel="noopener noreferrer">http://www.ceer.uz.zgora.pl/</a></li>
        <li>Advances in Thermal Processes and Energy Transformation: <a href="http://www.atpetjournal.com/index.html" target="_blank" rel="noopener noreferrer">http://www.atpetjournal.com/index.html</a></li>
      </ul>

      <hr className="custom-hr"/>
    </div>
  );
}

export default Profile;
